import React, {useState, useEffect} from 'react'
import {Header, Titulo} from '../elementos/Header'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import withRouter from './withRouter'
import Api from '../servicios/api'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioUsuario from './FormularioUsuario'
import favicon from '../imagenes/logoutm.png'
import Cargando from '../elementos/Cargando'

const EditarUsuario = (props) => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [usuario, setUsuario] = useState([]);

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        fetch(Api+"?consultarUsuarioID="+props.params.id)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setUsuario(datosRespuesta[0]);
        })
        .catch(console.log)
    }, [props]);

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <HelmetProvider>
                    <div>
                        <Helmet>
                            <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                            <title>Editar Usuario</title>
                        </Helmet>
                    </div>
                </HelmetProvider>

                <Header>
                        <Titulo>Editar Usuario</Titulo>
                        <BtnRegresar ruta="/usuarios"/>
                </Header>

                <FormularioUsuario  usuario={usuario}/>
            </>
        );
    }
}
 
export default withRouter(EditarUsuario);